<template xmlns:v-on="http://www.w3.org/1999/xhtml">
<div>
  <headlink></headlink>
  <div class="container ui-flex ui-flex-pack-center">
             
    <div class="right-container ui-center 	" >
      <ul class="ul-li-list " >
        <li  class="ui-border-b ui-flex  ui-flex-align-center ui-flex-pack-center">
          子用户设备分配    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button type="button" class="btn btn-primary" v-on:click="add()">添加</button>
          <button type="button" class="btn btn-primary" v-on:click="up(pageSize-1)">上一页</button>&nbsp;&nbsp;&nbsp;&nbsp;<span id="ye"></span>&nbsp;&nbsp;&nbsp;&nbsp;<button type="button" class="btn btn-primary" v-on:click="down(pageSize+1)">下一页</button>
        </li>
      </ul>
    
     <ul class="ul-li-list " >
        <li v-for="eq in eqList"  v-on:click="addActive(eq.eqId)" class="ui-border-b ui-flex  ui-flex-align-center ui-flex-pack-center">
          <p>
          	<input type="checkbox"   class="lv" name="shebei"  v-bind:value="eq.eqId" />
          	{{eq.eqName}}</p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<p>{{eq.eqId}}</p>
        </li>
      </ul>
      
    </div>
  </div>
  <div class="alert" v-show="alertFlag"  >
    <div class="dialog" >
      <div style="text-align: center;color:red;" >{{msg}}</div>
      <div style="padding: 20px;padding-bottom: 0; text-align: center;"  ><button class="btn-type" v-on:click="removeUser()">确定</button><button v-on:click="showWin(false)" class="btn-type btn-close" >取消</button></div>
    </div>
  </div>
</div>
</template>

<script>
import headlink from '@/components/common/headlink'

export default {
  name: 'dao',
  data () {
    return {
    	pageNum:9,
    	totoCount:"",
      pageSize:1,
      eqId:"",
      eqList:{},
      alertFlag:false
    }
  },
  methods:{
  	 down:function(pageSize){
  	  	 if(pageSize < 1){
           pageSize=1;
        }
  		   const history = window.sessionStorage;
       var uId = history.getItem("user");
    var uid = this.$route.params.uId;
    this.$http.post('/ZYun/HttpService.do', {
      "serviceCode":"1012",
       "uId":uId,
       "pageNum":this.pageNum,
        "pageSize" : pageSize

    })
      .then((response) => {
        if(response.data.respCode=="0000"){
          console.log(response)
          this.eqList = response.data.eqList;
          this.pageSize = pageSize;
          $("#ye").html(pageSize);
          	this.pageSize= parseInt(this.pageSize);
          
          this.totoCount=response.data.totoCount;
        }else{
          console.log(response);
        }
      })
      .catch((response) =>{
        console.log(response);
      });
  		 
 },
  	up:function(pageSize){
  		 if(pageSize < 1){
           pageSize=1;
        }
  		   const history = window.sessionStorage;
       var uId = history.getItem("user");
    var uid = this.$route.params.uId;
    this.$http.post('/ZYun/HttpService.do', {
      "serviceCode":"1012",
       "uId":uId,
       "pageNum":this.pageNum,
        "pageSize" : pageSize

    })
      .then((response) => {
        if(response.data.respCode=="0000"){
          console.log(response)
           this.eqList = response.data.eqList;
        this.pageSize = pageSize;
         $("#ye").html(pageSize);
        this.pageSize= parseInt(this.pageSize);
          this.totoCount=response.data.totoCount;
        }else{
          console.log(response);
        }
      })
      .catch((response) =>{
        console.log(response);
      });
  		 
 },
  	
   add :function(){
   	  
   	  console.log("ok");
   
   	  var eqList = new Array();
			$.each($('input[name="shebei"]:checked'), function() {
         var person=new Object();
          person.eqId=$(this).val();
         eqList.push(person);
});
		         var uid=this.$route.params.uId;
    	   					function zqdsData (){
    var json = {
    	
										"serviceCode": "1032",
									  "eqList":eqList,
										"userId":uid
								}
									return json;
		}
				
		  $.ajax({
		    	       type: "post",
									url: "http://59.110.64.112:8080/ZYun/HttpService.do",
									contentType: "application/json; charset=utf-8",
									async: true,
									data: JSON.stringify(zqdsData()),
									dataType: 'json',
									success: function(e) {
										if("0000" == e.respCode) {
									     jeBox.msg('成功！', {
												icon: 2,
												time: 3
											});
              
									}else{
										jeBox.msg('失败！'+e.respMsg, {
												icon: 3,
												time: 3
											});
									}
										
								}
			
			
	})
			
		
		
		
		
			

 },
    addActive:function(eqId){
    	
      this.eqId = eqId;
      $(".ul-li-list li").removeClass("active");
      $("#"+eqId).addClass("active");
    }
  },
  mounted: function () {
    const history = window.sessionStorage;
  var uId = history.getItem("user");
    var uid = this.$route.params.uId;
    this.$http.post('/ZYun/HttpService.do', {
      "serviceCode":"1012",
       "uId":uId,
       "pageNum":this.pageNum,
        "pageSize" :this.pageSize

    })
      .then((response) => {
        if(response.data.respCode=="0000"){
          console.log(response)
          this.eqList = response.data.eqList;
          $("#ye").html(this.pageSize);
          this.pageSize= parseInt(response.data.pageSize);
          
          this.totoCount=response.data.totoCount;
        }else{
          console.log(response);
        }
      })
      .catch((response) =>{
        console.log(response);
      });
  },
  components: {
    headlink:headlink
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/index.css" >
</style>



// WEBPACK FOOTER //
// src/components/userManage/dao.vue